// extracted by mini-css-extract-plugin
export default {"headline":"SystemRequirementType_headline__gtKmW","selection":"SystemRequirementType_selection__Uxrh8"};